module.exports = "<div class=\"TopLevel-Page Homepage-1 Gray-BG\" [style.margin-top]=\"dbService.navHeight + 'px'\" >\r\n</div>\r\n"